// Standalone, zod-free home for InfoModalVersion. Lives in storefront/common so
// value-importing this enum (e.g. from the checkout UI extension bundle) does
// not drag in the large, zod-heavy redo/model modules.

export enum InfoModalVersion {
  V1 = "v1",
  V2 = "v2",
}
